import { render, staticRenderFns } from "./subAccount.vue?vue&type=template&id=8a42fc34"
import script from "./subAccount.vue?vue&type=script&lang=js"
export * from "./subAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports